import Emitter from './event-emitter-machine';
export class StateMachine {
    value;
    context;
    events = { machineStateChanged: 'machineStateChanged' };
    emitter = new Emitter();
    definition;
    constructor(stateMachineDefinition) {
        this.definition = stateMachineDefinition;
        this.value = stateMachineDefinition.initialState;
        this.context = stateMachineDefinition.context;
    }
    makeTransition(currentState, trigger, contextData) {
        const currentStateDefinition = this.definition.states[currentState];
        const destinationTransition = currentStateDefinition.transitions[trigger];
        if (!destinationTransition)
            return;
        const destinationState = destinationTransition.target;
        const destinationStateDefinition = this.definition.states[destinationState];
        const payload = {
            updateContext: this.updateContext.bind(this),
            getFullContext: this.getFullContext.bind(this),
            contextData,
            trigger,
        };
        destinationTransition.action?.(payload);
        currentStateDefinition.actions.onExit?.(payload);
        destinationStateDefinition.actions.onEnter?.(payload);
        this.value = destinationState;
        this.emit(this.events.machineStateChanged, payload);
        return this.value;
    }
    updateContext(contextData) {
        this.context = { ...this.context, ...contextData };
    }
    getFullContext() {
        return this.context;
    }
    on(event, callback) {
        this.emitter.on(event, callback);
    }
    emit(event, payload, ...other) {
        this.emitter.emit(event, payload, ...other);
    }
}
